import type CustomerContactPreferences from "~/domains/subscription/CustomerContactPreferences";
import type { AxiosService } from "./axios.service";

export class SubscriptionService {
  $axios: AxiosService;
  apiUrl: string;

  constructor($axios: AxiosService, apiUrl: string) {
    this.$axios = $axios;
    this.apiUrl = apiUrl;
  }

  async getCustomerContactPreferences(customerId: number, sqldbid: number): Promise<CustomerContactPreferences> {
    const response = await this.$axios.get<CustomerContactPreferences>(
      `${this.apiUrl}Subscriptions/RGS/Customer/${customerId}/Company/${sqldbid}/ContactPreferences`,
    );
    return response.data;
  }

  async patchCustomerContactPreferences(
    customerId: number,
    sqldbid: number,
    customerContactPreferences: Partial<CustomerContactPreferences>
  ) {
    const response = await this.$axios.patch(
      `${this.apiUrl}Subscriptions/RGS/Customer/${customerId}/Company/${sqldbid}/ContactPreferences`,
      customerContactPreferences,
    );
    return response.data;
  }

  async putCustomerContactPreferences(
    customerId: number,
    sqldbid: number,
    customerContactPreferences: CustomerContactPreferences
  ): Promise<CustomerContactPreferences> {
    const response = await this.$axios.put<CustomerContactPreferences>(
      `${this.apiUrl}Subscriptions/RGS/Customer/${customerId}/Company/${sqldbid}/ContactPreferences`,
      customerContactPreferences,
    );
    return response.data;
  }
}
